<template lang="pug">
modal#rejected-envelope-modal(
  :close-button-label='$t("button.cancel")'
  :no-footer='isPublic'
  :process-button-label='$t("button.ok")'
  :show-cancel-button='false'
  :title='$t("modal.rejectedEnvelope.title")'
  @process='$emit("envelope-rejected")'
  ref='modal'
  size='sm'
)
  p {{ $t('modal.rejectedEnvelope.message') }}
  .text-center.mt-4
    img.img-fluid(src='/img/ilustrations/canceled-rejected-envelope.svg')
  buttons-login-and-create-account.mt-4(v-if='isPublic')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import ButtonsLoginAndCreateAccount from '@/modules/business/components/molecules/ButtonsLoginAndCreateAccount.vue';

export default {
  name: 'RejectEnvelopeModal',
  components: {
    Modal,
    ButtonsLoginAndCreateAccount,
  },
  props: {
    isPublic: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
